






































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import moment from 'moment-timezone'
import { formatNumber } from '@/utils/helpers'
import ExportPDF from './ExportPDF/ExportPDF.vue'
import constants from '@/utils/constants'
@Component({
  filters: {
    formatPrice(val: any) {
      let date: any = val
      return formatNumber(date)
    },
    formatDate(val: any) {
      let date: any = val
      if (moment(date).isValid()) {
        date = moment(date).format('MMM DD, YYYY HH:mm:ss')
      }
      return date
    },
  },
  components: {
    ExportPDF,
  },
})
export default class BillDetail extends Vue {
  @Prop() detailButton!: any
  @Prop() item!: any
  @Prop(String) billItemStatus!: String
  @Prop(Object) orderStatus!: Object
  @Prop(Function) hideOrderDetail!: Function
  @Prop(Function) updateBillStatus!: Function
  @Prop(Function) cancelBill!: Function
  @Prop(String) activeOrderStatus!: any
  openStatusShowMenu: Array<any> = []
  payOnlineStatusShowMenu: Array<any> = []
  payFailedStatusShowMenu: Array<any> = []
  padStatusShowMenu: Array<any> = []
  payOnCashierStatusShowMenu: Array<any> = []
  cancelStatusShowMenu: Array<any> = []
  compleateStatusShowMenu: Array<any> = []
  constants: any = constants
  get includeAllMenu() {
    return this.$store.getters.GetIncludeAllMenu
  }

  mounted() {
    if (
      this.item.billing_status === 'OPEN' ||
      this.item.billing_status === 'PAYING_ON_CASHIER' ||
      this.item.billing_status === 'PAYING_ONLINE_FAILED' ||
      this.item.billing_status === 'PAYING_AT_HOTEL'
    ) {
      this.item.sub_orders.map((items) => {
        items.menu_items.map((item) => {
          if (items.order_status !== constants.UPPER_CANCELLED) {
            item.notCancelled = 1
          } else {
            item.notCancelled = 0
          }
          this.openStatusShowMenu.push(item)
          this.payOnCashierStatusShowMenu.push(item)
          this.payFailedStatusShowMenu.push(item)
        })
      })
    } else if (this.item.billing_status === 'PAYING_ONLINE') {
      this.item.sub_orders.map((items) => {
        items.menu_items.map((item) => {
          if (items.order_status !== constants.UPPER_CANCELLED) {
            item.notCancelled = 1
          } else {
            item.notCancelled = 0
          }
          this.payOnlineStatusShowMenu.push(item)
        })
      })
    } else if (this.item.billing_status === constants.UPPER_CANCELLED) {
      this.item.sub_orders.map((items) => {
        if (items.cancel_reason === 'BILLING_CANCEL') {
          items.menu_items.map((item) => {
            this.cancelStatusShowMenu.push(item)
          })
        }
      })
    } else if (
      this.item.billing_status === 'PAID' ||
      this.item.billing_status === 'COMPLETED'
    ) {
      this.item.sub_orders.map((items) => {
        items.menu_items.map((item) => {
          if (items.order_status !== constants.UPPER_CANCELLED) {
            item.notCancelled = 1
          } else {
            item.notCancelled = 0
          }
          this.padStatusShowMenu.push(item)
          this.compleateStatusShowMenu.push(item)
        })
      })
    }
  }

  triggerDownload(orderType, orderID) {
    ;(this.$refs as any).isDownloadPDF.download(orderType, orderID)
  }
}
